import {observable, action, computed} from 'mobx';
import http from '../http'
import * as VKID from '@vkid/sdk';
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

class AuthStore {
    _routerStore;
    @observable loading = false;
    @observable user = null;
    @observable registerEmailError = null;
    @observable redirectUrl = null;
    @observable loadVkAuth = false;
    @observable authData = {
        name: null,
        social_type: null,
        social_id: null,
        social_token: null,
        email: '',
        is_social_email: false,
        photo: null,
    };
    @observable token = null;
    @observable errorAuth = null;
    @observable showEmailModal = false;
    @observable modalVisibility = false;
    @observable is_mobile = false;


    @computed get errorMessage() {
        return this.registerEmailError ? this.registerEmailError : this.errorAuth;
    }

    constructor(routerStore) {
        this._routerStore = routerStore;
        this.is_mobile = window.innerWidth <= 768;
        try {
            this.user = JSON.parse(localStorage.getItem('user'));
        } catch (e) {
            this.logout();
            return;
        }

        this.token = localStorage.getItem('token')

        if (this.token && !this.user) {
            this.user = this.currentUser()
        }

        if (!this.checkAuth()) {
            this.logout();
        }
    }

    init = async () => {
        if (window.location.hash) {
            await this.vkAuth();
        }
    }

    @action setData(user) {
        const token = user.token
        localStorage.setItem('token', token);
        delete user.token;
        localStorage.setItem('user', JSON.stringify(user));
        this.user = user;
        this.token = token;
    }

    @action setUserPhone(phone) {
        let user = this.user
        user.phone = phone
        this.user = user
        localStorage.setItem('user', JSON.stringify(user));
    }

    checkAuth = () => {
        return this.token !== undefined && this.token !== 'undefined' && this.token !== null && this.user !== null;
    }

    @action
    vkAuth = async (data) => {
        if (!data.user_id || !data.access_token) {
            return false;
        }
        return Promise.resolve()
            .then(() => this.loadVkAuth = true)
            .then(() => {
                this.authData.email = data.email ?? '';
                this.authData.is_social_email = data.email !== '';
                this.authData.social_type = 'vk';
                this.authData.social_id = data.user_id;
                this.authData.social_token = data.access_token;
            })
            .then(this.auth)
            .catch(() => {
                this.loading = true
            })
    }

    @action
    vkStartAuth = async () => {
        return Promise.resolve()
            .then(() => {
                VKID.Config.init({
                    app: 8024134,
                    redirectUrl: 'https://tonesky.ru/booking/auth',
                    responseMode: VKID.ConfigResponseMode.Callback,
                    mode: VKID.ConfigAuthMode.InNewWindow,
                    scope: 'email phone vkid.personal_info',
                });
                VKID.Auth.login()
                    .then(function (data) {
                        return VKID.Auth.exchangeCode(data.code, data.device_id);
                    })
                    .then(this.vkAuth)
            })
            .catch((e) => {
                this.loading = false;
                console.log(e)
                this.errorAuth = 'Что-то пошло не так :('
            })
    }

    @action
    googleAuth = async (data) => {
        if (!data.id || !data.access_token || !data.email) {
            return false;
        }

        return Promise.resolve()
            .then(() => {
                this.authData.social_type = 'google';
                this.authData.social_id = data.id;
                this.authData.social_token = data.access_token;
                this.authData.name = data.name;
                this.authData.email = data.email;
                this.authData.photo = data.picture;
                this.authData.is_social_email = true;
            })
            .then(this.auth)
            .catch(console.log)
            .catch(() => this.loading = true)
    }

    @action
    appleAuth = async (data) => {
        if (!data.authorization) {
            return false;
        }
        return Promise.resolve()
            .then(() => {
                const decodedTokenData = jwt_decode(data.authorization.id_token);
                this.authData.social_type = 'apple';
                this.authData.social_id = decodedTokenData.sub;
                this.authData.social_token = data.authorization.id_token;
                this.authData.name = data.user && data.user.name ? `${data.user.name.firstName} ${data.user.name.lastName}` : null;
                this.authData.email = data.user
                && data.user.email
                && typeof data.user.email === 'string'
                && !data.user.email.includes('privaterelay.appleid.com')
                    ? data.user.email
                    : null;
                this.authData.is_social_email = this.authData.email !== null;
            })
            .then(this.auth)
            .catch(() => this.loading = true)
    }

    @action
    onAuthClick = async () => {
        return Promise.resolve()
            .then(() => this.loading = true)
    }

    @action
    authWithEmail = async () => {
        return Promise.resolve()
            .then(this.auth)
    }

    handleChangeEmail = (event) => {
        this.authData.email = event.target.value;
    };

    @action
    currentUser = async () => {
        return http.get(`/user/get-current`)
            .then(({data}) => {
                this.setData(data.content)
            })
    }

    @action
    getAuthFromApp = () => {
        let cookieToken = Cookies.get('AuthToken');
        if (cookieToken && !this.checkAuth()) {
            localStorage.setItem('token', cookieToken);
        }
    }

    redirect(url) {
        this._routerStore.history.push(url)
    }

    @action logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.user = null;
        this.token = null;
    }

    @action isAuthPage = () => {
        return this._routerStore && this._routerStore.location.pathname === '/booking/auth'
    }

    @action
    auth = async () => {
        return await http.post('/user/social-auth', this.authData)
            .then(({data}) => {
                this.setData(data.content)
                this.showEmailModal = false;
                this.closeModal()
                this.registerEmailError = null;
                this.errorAuth = null;
                this.loading = false;
                let url = this.redirectUrl;
                this.redirectUrl = null;
                if (url) {
                    this.redirect(url)
                }
            })
            .catch(({response}) => {
                const {status} = response;
                this.loading = false;
                if (status === 449) {
                    this.showEmailModal = true;
                    this.modalVisibility = true
                } else if (status === 406) {
                    this.registerEmailError = 'Неверно введен e-mail.'
                } else {
                    this.errorAuth = 'Что-то пошло не так :('
                }
            });
    }

    responseError = (social, response) => {
        console.log('-------------------------');
        console.log(`Type: ${social}`);
        console.log(response);
        console.log('-------------------------');
    }

    @action authAndRedirect = (url) => {
        if (this.checkAuth()) {
            this.redirect(url)
        } else {
            this.redirectUrl = url;
            this.showModal()
        }
    }

    @action showModal = () => {
        this.modalVisibility = true;
    }

    @action closeModal = () => {
        this.modalVisibility = false;
    }
}

export default AuthStore;
export {AuthStore};
